import Cookies from 'js-cookie'
import { settings } from '../../main/configs/settings'

export const setCookie = (name: string, value: string | object) => {
  const stringValue = typeof value === 'string' ? value : JSON.stringify(value)

  if (window.location.origin.indexOf('localhost') !== -1) {
    Cookies.set(name, stringValue)
  }

  Cookies.set(name, stringValue, { domain: settings.DOMAIN })
}

export const setDefaultToken = (token: string | object) => {
  if (settings.TOKEN) {
    setCookie(settings.TOKEN, token)
  }
}
